import { render, staticRenderFns } from "./ListadoTurnosArqueados.vue?vue&type=template&id=631a1132&"
import script from "./ListadoTurnosArqueados.vue?vue&type=script&lang=js&"
export * from "./ListadoTurnosArqueados.vue?vue&type=script&lang=js&"
import style0 from "./ListadoTurnosArqueados.vue?vue&type=style&index=0&id=631a1132&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports